export enum FhirCodeSystem {
    QuestionnaireItemCategory = 'https://connect.ksyos.com/fhir/codeSystem/questionnaireItemCategory',
}
